import React, { useState } from "react";
import { Table, Tag, Button, Modal, Descriptions, Space, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const CoptDetailsTable = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCopt, setSelectedCopt] = useState(null);

  const showModal = (record) => {
    setSelectedCopt(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedCopt(null);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "copt_name",
      key: "copt_name",
    },
    {
      title: "Make",
      dataIndex: "copt_maker",
      key: "copt_maker",
    },
    {
      title: "Model",
      dataIndex: "copt_model",
      key: "copt_model",
    },
    {
      title: "Selected Parameters",
      dataIndex: "selected_parameters",
      key: "selected_parameters",
      width: "50%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((param, index) => (
              <Tag color="blue" key={index}>
                {param}
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },
    {
      title: "Other Parameters",
      dataIndex: "other_parameters",
      key: "other_parameters",
      width: "20%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((item, index) => (
              <Tag color="green" key={index}>
                {item.name} ({item.unit})
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Details">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => showModal(record)}
              size="small"
            >
              View
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        bordered
        className="custom-table"
      />

      <Modal
        title="COPT Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        {selectedCopt && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Title">{selectedCopt.copt_name}</Descriptions.Item>
            <Descriptions.Item label="Make">{selectedCopt.copt_maker}</Descriptions.Item>
            <Descriptions.Item label="Model">{selectedCopt.copt_model}</Descriptions.Item>
            <Descriptions.Item label="Selected Parameters">
              {Array.isArray(selectedCopt.selected_parameters) &&
              selectedCopt.selected_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedCopt.selected_parameters.map((param, index) => (
                    <Tag color="blue" key={index}>
                      {param}
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Other Parameters">
              {Array.isArray(selectedCopt.other_parameters) &&
              selectedCopt.other_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedCopt.other_parameters.map((item, index) => (
                    <Tag color="green" key={index}>
                      {item.name} ({item.unit})
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
};

export default CoptDetailsTable;
